import { Component, Inject, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: "email",
    template: require('./email.component.html'),
    styles: [require('./email.component.css')]
})
export class EmailComponent implements OnChanges {

    @ViewChild(SignaturePad) signaturePad: SignaturePad;
    private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
        'minWidth': 5,
        'canvasWidth': window.innerWidth - 16,
        'canvasHeight': 200
    };
    report: CollisionReport;
    statementModel: StatementData = <StatementData>{};

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private domSanitizer: DomSanitizer) {
        this.report = appcomponent.getReport();
        
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }

        
        this.signaturePad = <SignaturePad>{};

        document.body.scrollTop = 0;
        this.textareaWidth();
    }

    ngAfterViewInit() {
        // this.signaturePad is now available
        //this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
        //this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }

    textareaWidth(): void {
        var textContainer = document.getElementById('textContainer');
        if (textContainer != null) {
            textContainer.style.width = (window.innerWidth - 100).toString();
        }
    }

    onPhoneInput(): void {
        var phone = this.report.PrimaryPhoneNumber.replace(/[^0-9]/g, "");
        var v = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.report.PrimaryPhoneNumber = v;
    }

    onSetRefused(event: any) {
        console.log(event);
        this.report.EmailAddress = "REFUSED";
        var EmailAddress = document.getElementById('EmailAddress');
        if (EmailAddress != null) {

        }
    }

    drawStart() {
        // will be notified of szimek/signature_pad's onBegin event
    }

    drawComplete() {
        // will be notified of szimek/signature_pad's onEnd event
        //this.addSignature();
    }

    addSignature() {

        if (this.signaturePad.isEmpty()) {
            alert('Please provide your signature');
            return;
        }
        var signature = this.signaturePad.toDataURL();
        this.report.StatementSignature = signature;
    }

    deleteSignature() {
        this.report.StatementSignature = "";
    }

    addSignatureOnSubmit() {
        if (this.report.StatementSignature == null || this.report.StatementSignature == "")
        {
            this.addSignature();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
            }
        }
        else
            console.log("Undefined");
    }

    onBack(): void {
/*
        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            this.BackAndPost("statement")
        }
        else {
            this.BackAndPost("trafficevent");
        }
*/
        this.BackAndPost("checklist");
    }

    private BackAndPost(page: string): void {
        this.report.CurrentPage = page;
        this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }

    onSubmit(): void {
        //   alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));

        if (!this.isValid())
            return;

        this.addSignatureOnSubmit()

        this.report.BadgeNumber = "8910";
        this.ValidateAndPost("yourinfo");
    /*
        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            this.report.BadgeNumber = "8910";
            this.submitStatement(this.report.CollisionReportId);
            this.ValidateAndPostPedCyc("counsellorreview");
        }
        else {
            this.ValidateAndPost("counsellorreview");
            this.submitStatement(this.report.CollisionReportId);
        }
      */

        //GO TO NEXT PAGE
    }

    //private ValidateAndPostPedCyc(page: string) {
    //    var isValid = this.isValid();
    //    if (isValid) {
    //        //this.report.IsCouncellorReviewPageValid = true;
    //        //this.report.CollisionLocation = this.location;
    //        //this.report.IsMapPageValid = true;
    //        this.report.IsEmailPageValid = true;
    //        this.report.IsFinalized = true;
    //        this.report.CurrentPage = page;
    //        this.appcomponent.setReport(this.report);
    //        // this.router.navigate([page]);
    //    }
    //}

    private ValidateAndPostPedCyc(page: string) {
        var url = this.baseUrl + "api/report/Badge/" + this.report.BadgeNumber;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as number;
                if (data != null && data > 0) {
                    this.report.CounsellorId = data;
                    this.report.IsEmailPageValid = true;
                    //this.report.IsFinalized = true;
                    this.report.CurrentPage = page;
                    this.appcomponent.setReport(this.report);
                    this.router.navigate([page]);

                }
                else {
                    alert("Please enter a valid badge number");
                }

            }, error => console.log(error));
    }

    private ValidateAndPost(page: string) {
        //var url = this.baseUrl + "api/report/Badge/" + this.report.BadgeNumber;
        //var data: any;
        //this.http
        //    .get(url)
        //    .subscribe(res => {
        //        data = res as number;
        //        if (data != null && data > 0) {
        //            this.report.CounsellorId = data;
        //            this.report.IsEmailPageValid = true;
        //            this.report.CurrentPage = page;
        //            this.appcomponent.setReport(this.report);
        //            this.router.navigate([page]);

        //        }
        //        else {
        //            alert("Please enter a valid badge number");
        //        }

        //    }, error => console.log(error));

        this.report.CounsellorId = 0;
        this.report.IsEmailPageValid = true;
        this.report.CurrentPage = page;
        this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }

    isValid(): boolean {
        if (this.report.StatementSignature == null || this.report.StatementSignature.length == 0) {
            alert('Please provide your signature');
            return false;
        }
        return true;
    }

    submitStatement(reportid: number): void {
        this.printStatement(this.report.CollisionDescription, reportid, this.report.EmailAddress);
    }

    printStatement(value: string, ReportId: any, email: string): void {
        // var url = this.baseUrl + "api/Statement/GetStatement/" + this.report.CollisionReportId + "/" + this.report.ApproximateSpeed + "/" + this.report.CollisionDescription;
        var url = this.baseUrl + "api/Statement";
        var data: StatementSuccess;

        //this.statementModel.approxSpeed = speed;
        //this.statementModel.Statement = this.report.CollisionDescription;
        //if (this.report.CollisionReportId == 0) {
        //    this.statementModel.collisionReportId = ReportId;
        //}
        this.statementModel.collisionReportId = this.appcomponent.getReport().CollisionReportId; //this.report.CollisionReportId 
        this.statementModel.diagram = this.report.Diagram;
        this.statementModel.signature = this.report.StatementSignature;
        this.statementModel.email = email;
        this.http
            .post(url, this.statementModel)
            .subscribe(res => {
                data = res as StatementSuccess;
                if (data.speed != 0) {
                }
                else {
                }
            }, error => console.log(error));
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
                
            });
    }

}